const isAdmin = (conversation, user) => {
  return conversation?.attributes?.admins?.find(
    (member) => member?.email && member.email === user?.attributes?.email
  );
};

export default isAdmin;
